const styles = {
  backdrop: {
    backgroundColor: "#fff",
    zIndex: 9999,
    position: "absolute",
    borderRadius: 2,
  },
};
export default styles;
